import { of } from "rxjs";
import {
  mergeMap,
  groupBy,
  filter,
  distinctUntilKeyChanged,
  switchMap,
  map,
} from "rxjs/operators";

export const ParentSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),

      mergeMap((group$) =>
        group$.pipe(
          filter(
            (entity) =>
              entity.hasOwnProperty("object3D") &&
              entity.object3D &&
              entity.hasOwnProperty("parent") &&
              entity.parent
          ),

          distinctUntilKeyChanged("parent"),

          // insert object3D
          switchMap((entity) => {
            if (entity.object3D) {
              return world.object3DManager
                .getObject3D$(entity.object3D)
                .pipe(map((object3D) => ({ ...entity, object3D })));
            } else {
              return of(entity);
            }
          }),

          // insert parent
          switchMap((entity) => {
            if (entity.parent) {
              const parentId = entity.parent;
              return world.object3DManager
                .getObject3D$(parentId)
                .pipe(map((parent) => ({ ...entity, parent })));
            } else {
              return of(entity);
            }
          })
        )
      )
    )

    .subscribe((entity) => {
      const { parent, object3D } = entity;

      if (object3D && parent && object3D.parent !== parent) {
        if (object3D.parent) {
          object3D.parent.remove(object3D);
        }
        parent.add(object3D);
      }
    });
};

export default ParentSystem;
